export const SIDEBAR_COLLAPSED_KEY = "kamvu.sidebarCollapsed";

const readSidebarCollapsed = () => {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
  } catch (e) {
    return false;
  }
};

export default {
  appLoaded: false,
  snackbar: {
    text: "",
    enabled: false,
  },
  loader: false,
  drawer: false,
  isMobileView:  window.innerWidth <= 768,
  // Sidebar de escritorio contraído (solo iconos). Se recuerda entre sesiones.
  sidebarCollapsed: readSidebarCollapsed(),
};
